module.exports = __webpack_public_path__ + "a4490bb5aa40b913820e8be8d24bce7d.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/2.m4a
// module id = 7pC+
// module chunks = 1